
<template>
  <header class="navbar-expand-md">
    <div class="collapse navbar-collapse" id="navbar-menu">
      <div class="navbar">
        <div class="container-xl">
          <ul class="navbar-nav">
            <li class="nav-item" :class="{ active: $route.name == 'home' }">
              <a class="nav-link" href="/home">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                  <i class="fa-solid fa-house-chimney-window"></i>
                </span>
                <span class="nav-link-title">
                  首页
                </span>
              </a>
            </li>
            <li class="nav-item" :class="{ active: $route.name == 'home_assistant' }">
              <a class="nav-link" href="/home_assistant">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                  <i class="ass homeassistant"></i>
                </span>
                <span class="nav-link-title">
                  Home Assistant for Sumsg Smart
                </span>
              </a>
            </li>
            <li class="nav-item" :class="{ active: $route.name == 'home_assistant2' }">
              <a class="nav-link" href="/home_assistant2">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                  <i class="ass homeassistant"></i>
                </span>
                <span class="nav-link-title">
                  Home Assistant for MQTT
                </span>
              </a>
            </li>
            <!-- <li class="nav-item" :class="{ active: $route.name == 'home' }">
              <a class="nav-link" href="/home">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                  <i class="ass homebridge"></i>
                </span>
                <span class="nav-link-title">
                  Home Bridge
                </span>
              </a>
            </li> -->

          </ul>
        </div>
      </div>
    </div>
  </header>
</template>
<style scoped>
.ass {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 1.5rem auto;
  position: relative;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  aspect-ratio: 1.33333;
  vertical-align: bottom;
}

.homeassistant {
  background-image: url('~@/../public/img/homeassistant.svg');
  background-size: 1.3em auto;
}

.homebridge {
  background-image: url('~@/../public/img/homebridge.svg');
  background-size: 1.3em auto;
}
</style>
